interface TTLProps {
  value: number;
  unit: string;
  seconds: number;
}

const ttlOptions: TTLProps[] = [
  { value: 0, unit: 's', seconds: 0 },
  { value: 300, unit: 's', seconds: 300 },
  { value: 1800, unit: 's', seconds: 1800 },
  { value: 1, unit: 'hour', seconds: 3600 },
  { value: 4, unit: 'hour', seconds: 14400 },
  { value: 1, unit: 'day', seconds: 86400 },
  { value: 5, unit: 'day', seconds: 432000 },
  { value: 7, unit: 'day', seconds: 604800 },
];

export const getValueAndUnit = (seconds: number): { value: number; unit: string } => {
  return ttlOptions.find((opt) => opt.seconds === seconds) ?? { value: seconds, unit: 's' };
};

export const getSeconds = (value: number, unit: string): string => {
  return String(ttlOptions.find((opt) => opt.value === value && opt.unit === unit)?.seconds) ?? 0;
};
